function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { dom } from '../../util';
import { edgeMap as alignMap } from '../../balloon/alignMap';
var VIEWPORT = 'viewport'; // IE8 not support pageXOffset

var getPageX = function getPageX() {
  return window.pageXOffset || document.documentElement.scrollLeft;
};

var getPageY = function getPageY() {
  return window.pageYOffset || document.documentElement.scrollTop;
};
/**
 * @private get element rect
 * @param       {Element} elem
 * @return      {Object}
 * 注意，该方法在处理存在css transform: translate时结果不对
 */


function _getElementRect(elem) {
  var offsetTop = 0;
  var offsetLeft = 0;
  var scrollTop = 0;
  var scrollLeft = 0;
  var _elem = elem,
      offsetHeight = _elem.offsetHeight;
  var _elem2 = elem,
      offsetWidth = _elem2.offsetWidth; // eslint-disable-next-line no-cond-assign

  do {
    if (!isNaN(elem.offsetTop)) {
      offsetTop += elem.offsetTop;
    }

    if (!isNaN(elem.offsetLeft)) {
      offsetLeft += elem.offsetLeft;
    }

    if (!isNaN(elem.scrollTop)) {
      scrollTop += elem.scrollTop;
    }

    if (!isNaN(elem.scrollLeft)) {
      scrollLeft += elem.scrollLeft;
    }
  } while ((elem = elem.offsetParent) !== null);

  return {
    top: offsetTop - scrollTop - (document.documentElement.scrollTop || document.body.scrollTop),
    left: offsetLeft - scrollLeft - (document.documentElement.scrollLeft || document.body.scrollLeft),
    height: offsetHeight,
    width: offsetWidth
  };
}
/**
 * @private get viewport size
 * @return {Object}
 */


function _getViewportSize() {
  return {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight
  };
}

var Position = /*#__PURE__*/function () {
  /**
   * @public static place method
   * @param  {Object}       props
   *     @param  {String}   props.role
   *     @param  {DOM}      props.pinElement
   *     @param  {DOM}      props.baseElement
   *     @param  {String}   props.align
   *     @param  {Number}   props.offset
   *     @param  {Boolean}  props.needAdjust
   *     @param  {Boolean}  props.isRtl
   *     @param  {DOM}      props.containerNode
   * @return {Position}
   */
  function Position(props) {
    _classCallCheck(this, Position);

    _defineProperty(this, "_getParentScrollOffset", function (elem) {
      var top = 0;
      var left = 0;

      if (elem && elem.offsetParent) {
        if (!isNaN(elem.offsetParent.scrollTop)) {
          top += elem.offsetParent.scrollTop;
        }

        if (!isNaN(elem.offsetParent.scrollLeft)) {
          left += elem.offsetParent.scrollLeft;
        }
      }

      return {
        top: top,
        left: left
      };
    });

    this.role = props.role;
    this.pinElement = props.pinElement;
    this.baseElement = props.baseElement;
    this.align = props.align || 'tl tl';
    this.offset = props.offset || [0, 0];
    this.needAdjust = props.needAdjust || false;
    this.isRtl = props.isRtl || false;
    this.containerNode = props.containerNode;
  }

  _createClass(Position, [{
    key: "setPosition",
    value: function setPosition() {
      var pinElement = this.pinElement,
          baseElement = this.baseElement;

      var expectedAlign = this._getExpectedAlign();

      var isPinFixed;
      var isBaseFixed;
      var firstPositionResult;

      if (pinElement === VIEWPORT) {
        return;
      }

      if (dom.getStyle(pinElement, 'position') !== 'fixed') {
        dom.setStyle(pinElement, 'position', 'absolute');
        isPinFixed = false;
      } else {
        isPinFixed = true;
      }

      if (baseElement === VIEWPORT || dom.getStyle(baseElement, 'position') !== 'fixed') {
        isBaseFixed = false;
      } else {
        isBaseFixed = true;
      } // 根据期望的定位


      for (var i = 0; i < expectedAlign.length; i++) {
        var align = expectedAlign[i];

        var pinElementPoints = this._normalizePosition(pinElement, align.split(' ')[0], isPinFixed);

        var baseElementPoints = this._normalizePosition(baseElement, align.split(' ')[1], isPinFixed);

        var pinElementParentOffset = this._getParentOffset(pinElement);

        var pinElementParentScrollOffset = this._getParentScrollOffset(pinElement);

        var baseElementOffset = isPinFixed && isBaseFixed ? this._getLeftTop(baseElement) : baseElementPoints.offset();
        var top = baseElementOffset.top + baseElementPoints.y - pinElementParentOffset.top - pinElementPoints.y + pinElementParentScrollOffset.top;
        var left = baseElementOffset.left + baseElementPoints.x - pinElementParentOffset.left - pinElementPoints.x + pinElementParentScrollOffset.left; // 不直接将DOM定位过去，不仅有性能损耗，而且受绝对定位元素尺寸变化问题的影响
        // 假设DOM放置在left，top上，通过计算去判断是否在视口内
        // this._setPinElementPostion(pinElement, { left, top }, this.offset);

        if (!firstPositionResult) {
          firstPositionResult = {
            left: left,
            top: top
          };
        }

        if (this._isInViewport(pinElement, {
          left: left,
          top: top
        }, this.offset, this.containerNode)) {
          this._setPinElementPostion(pinElement, {
            left: left,
            top: top
          }, this.offset);

          return align;
        }
      } // This will only execute if `pinElement` could not be placed entirely in the Viewport


      var inViewportLeft = this._makeElementInViewport(pinElement, firstPositionResult.left, 'Left', isPinFixed);

      var inViewportTop = this._makeElementInViewport(pinElement, firstPositionResult.top, 'Top', isPinFixed);

      this._setPinElementPostion(pinElement, {
        left: inViewportLeft,
        top: inViewportTop
      }, this.offset);

      return expectedAlign[0];
    }
  }, {
    key: "_getParentOffset",
    value: function _getParentOffset(element) {
      var parent = element.offsetParent || document.documentElement;
      var offset;

      if (parent === document.body && dom.getStyle(parent, 'position') === 'static') {
        offset = {
          top: 0,
          left: 0
        };
      } else {
        offset = this._getElementOffset(parent);
      }

      offset.top += parseFloat(dom.getStyle(parent, 'border-top-width'), 10);
      offset.left += parseFloat(dom.getStyle(parent, 'border-left-width'), 10);
      offset.offsetParent = parent;
      return offset;
    }
  }, {
    key: "_makeElementInViewport",
    value: function _makeElementInViewport(pinElement, number, type, isPinFixed) {
      // pinElement.offsetParent is never body because wrapper has position: absolute
      // refactored to make code clearer. Revert if wrapper style changes.
      // let result = number;
      // const docElement = document.documentElement;
      // const offsetParent =
      //     pinElement.offsetParent || document.documentElement;
      // if (result < 0) {
      //     if (isPinFixed) {
      //         result = 0;
      //     }
      //     else if (
      //         offsetParent === document.body &&
      //         dom.getStyle(offsetParent, 'position') === 'static'
      //     ) {
      //         // Only when div's offsetParent is document.body, we set new position result.
      //         result = Math.max(
      //             docElement[`scroll${type}`],
      //             document.body[`scroll${type}`]
      //         );
      //     }
      // }
      // return result;
      return number < 0 && isPinFixed ? 0 : number;
    }
  }, {
    key: "_normalizePosition",
    value: function _normalizePosition(element, align, isPinFixed) {
      var points = this._normalizeElement(element, isPinFixed);

      this._normalizeXY(points, align);

      return points;
    }
  }, {
    key: "_normalizeXY",
    value: function _normalizeXY(points, align) {
      var x = align.split('')[1];
      var y = align.split('')[0];
      points.x = this._xyConverter(x, points, 'width');
      points.y = this._xyConverter(y, points, 'height');
      return points;
    }
  }, {
    key: "_xyConverter",
    value: function _xyConverter(align, points, type) {
      var res = align.replace(/t|l/gi, '0%').replace(/c/gi, '50%').replace(/b|r/gi, '100%').replace(/(\d+)%/gi, function (m, d) {
        return points.size()[type] * (d / 100);
      });
      return parseFloat(res, 10) || 0;
    }
  }, {
    key: "_getLeftTop",
    value: function _getLeftTop(element) {
      return {
        left: parseFloat(dom.getStyle(element, 'left')) || 0,
        top: parseFloat(dom.getStyle(element, 'top')) || 0
      };
    }
  }, {
    key: "_normalizeElement",
    value: function _normalizeElement(element, isPinFixed) {
      var _this = this;

      var result = {
        element: element,
        x: 0,
        y: 0
      };
      var isViewport = element === VIEWPORT;
      var docElement = document.documentElement;

      result.offset = function () {
        if (isPinFixed) {
          return {
            left: 0,
            top: 0
          };
        } else if (isViewport) {
          return {
            left: getPageX(),
            top: getPageY()
          };
        } else {
          return _this._getElementOffset(element);
        }
      };

      result.size = function () {
        if (isViewport) {
          return {
            width: docElement.clientWidth,
            height: docElement.clientHeight
          };
        } else {
          return {
            width: element.offsetWidth,
            height: element.offsetHeight
          };
        }
      };

      return result;
    }
  }, {
    key: "_getElementOffset",
    value: function _getElementOffset(element) {
      var rect = element.getBoundingClientRect();
      var docElement = document.documentElement;
      var body = document.body;
      var docClientLeft = docElement.clientLeft || body.clientLeft || 0;
      var docClientTop = docElement.clientTop || body.clientTop || 0;
      return {
        left: rect.left + (getPageX() - docClientLeft),
        top: rect.top + (getPageY() - docClientTop)
      };
    } // According to the location of the overflow to calculate the desired positioning

  }, {
    key: "_getExpectedAlign",
    value: function _getExpectedAlign() {
      var align = this.isRtl ? this._replaceAlignDir(this.align, /l|r/g, {
        l: 'r',
        r: 'l'
      }) : this.align;
      var expectedAlign = [align];

      if (this.needAdjust) {
        if (/t|b/g.test(align)) {
          expectedAlign.push(this._replaceAlignDir(align, /t|b/g, {
            t: 'b',
            b: 't'
          }));
        }

        if (/l|r/g.test(align)) {
          expectedAlign.push(this._replaceAlignDir(align, /l|r/g, {
            l: 'r',
            r: 'l'
          }));
        }

        if (/c/g.test(align)) {
          expectedAlign.push(this._replaceAlignDir(align, /c(?= |$)/g, {
            c: 'l'
          }));
          expectedAlign.push(this._replaceAlignDir(align, /c(?= |$)/g, {
            c: 'r'
          }));
        }

        expectedAlign.push(this._replaceAlignDir(align, /l|r|t|b/g, {
          l: 'r',
          r: 'l',
          t: 'b',
          b: 't'
        }));
      } // Tooltip的对齐方式是其子集，需要过滤掉部分


      if (this.role === 'tooltip') {
        var toolTipAlignSet = [align];
        var keys = Object.keys(alignMap);
        keys.forEach(function (k) {
          toolTipAlignSet.push(alignMap[k].align, alignMap[k].rtlAlign);
        });
        return Array.from(new Set(toolTipAlignSet));
      }

      return expectedAlign;
    } // Transform align order.

  }, {
    key: "_replaceAlignDir",
    value: function _replaceAlignDir(align, regExp, map) {
      return align.replace(regExp, function (res) {
        return map[res];
      });
    } // Detecting element is in the window， we want to adjust position later.

  }, {
    key: "_isInViewport",
    value: function _isInViewport(element, _ref, offset, containerNode) {
      var left = _ref.left,
          top = _ref.top;

      var viewportSize = _getViewportSize(); // 如果传入了 containerNode


      if (containerNode && containerNode.tagName !== 'BODY') {
        return left + offset[0] + element.offsetWidth < viewportSize.width + document.documentElement.scrollLeft && top + offset[1] + element.offsetHeight < viewportSize.height + document.documentElement.scrollTop;
      } // Avoid animate problem that use offsetWidth instead of getBoundingClientRect.


      return left + offset[0] >= document.documentElement.scrollLeft && // using strict < instead of <=, to handle the bug of container expaned on element placement
      // closing https://github.com/alibaba-fusion/next/issues/853
      left + offset[0] + element.offsetWidth < viewportSize.width + document.documentElement.scrollLeft && top + offset[1] >= document.documentElement.scrollTop && top + offset[1] + element.offsetHeight < viewportSize.height + document.documentElement.scrollTop;
    } // 在这里做RTL判断 top-left 定位转化为等效的 top-right定位

  }, {
    key: "_setPinElementPostion",
    value: function _setPinElementPostion(pinElement, postion) {
      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [0, 0];
      var top = postion.top,
          left = postion.left;

      if (!this.isRtl) {
        dom.setStyle(pinElement, {
          left: "".concat(left + offset[0], "px"),
          top: "".concat(top + offset[1], "px")
        });
        return;
      } // transfer {left,top} equaly to {right,top}


      var pinElementParentOffset = this._getParentOffset(pinElement);

      var _getElementRect2 = _getElementRect(pinElementParentOffset.offsetParent),
          offsetParentWidth = _getElementRect2.width;

      var _getElementRect3 = _getElementRect(pinElement),
          width = _getElementRect3.width;

      var right = offsetParentWidth - (left + width);
      dom.setStyle(pinElement, {
        left: 'auto',
        right: "".concat(right + offset[0], "px"),
        top: "".concat(top + offset[1], "px")
      });
    }
  }]);

  return Position;
}();

_defineProperty(Position, "VIEWPORT", VIEWPORT);

_defineProperty(Position, "place", function (props) {
  return new Position(props).setPosition();
});

export { Position as default };